/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseRequestGroup } from '../../models/course-request-group';

export interface ApiRequestCourseGetRequestGroupByIdGet$Params {
  id?: string;
}

export function apiRequestCourseGetRequestGroupByIdGet(http: HttpClient, rootUrl: string, params?: ApiRequestCourseGetRequestGroupByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequestGroup>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCourseGetRequestGroupByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CourseRequestGroup>;
    })
  );
}

apiRequestCourseGetRequestGroupByIdGet.PATH = '/api/Request/Course/GetRequestGroupById';
